import { emailRequired, lengthRequired, phone, phoneRequired } from '@polvo-labs/form-utils'
import TextArea from '../../components/Form/Fields/TextArea'
import FieldType from '../../components/Form/Fields/type'


export interface ContactAdvancedFormData {
  name: string
  email: string
  alternative_email?: string
  phone: string
  alternative_phone?: string
  message: string
  realties?: string
  uploads?: string
}

export type ContactAdvancedForm = keyof ContactAdvancedFormData

const fields: FieldType<ContactAdvancedForm>[] = [
  {
    name: 'name',
    data: {
      icon: 'text',
      label: 'Nome completo',
    },
    html: {
      maxLength: 100,
      minLength: 6,
      placeholder: 'Nome e sobrenome',
    },
    size: 1 / 2,
    validation: lengthRequired({ min: 6, max: 100 }),
  },
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'E-mail',
    },
    validation: emailRequired,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
    },
    size: 1 / 2,
  },
  {
    name: 'alternative_email',
    data: {
      icon: 'mail',
      label: 'E-mail alternativo',
    },
    // validation: email,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
      type: "email"
    },
    size: 1 / 2,
  },
  // {
  //   name: 'phone',
  //   data: {
  //     icon: 'phone',
  //     label: 'Telefone',
  //   },
  //   validation: phone,
  //   html: {
  //     maxLength: 20,
  //     placeholder: 'Telefone',
  //   },
  //   size: 1 / 2,
  // },
  // {
  //   name: 'alternative_phone',
  //   data: {
  //     icon: 'phone',
  //     label: 'Telefone alternativo',
  //   },
  //   validation: phone,
  //   html: {
  //     maxLength: 20,
  //     placeholder: 'Telefone',
  //   },
  //   size: 1 / 2,
  // },
  // {
  //   name: 'realties',
  //   component: SelectMultiple,
  //   data: {
  //     displayField: 'registry_office',
  //     label: 'Associar Imóveis',
  //     icon: 'home',
  //     options: [],
  //   },
  //   html: {
  //     // multiple: true
  //   },
  // },
  // {
  //   name: 'uploads',
  //   component: Upload,
  //   data: {
  //     label: 'Anexar arquivos',
  //   },
  // },
  {
    name: 'message',
    component: TextArea,
    data: {
      label: 'Mensagem',
      showCounter: true,
    },
    validation: lengthRequired({ min: 6, max: 1000 }),
    html: {
      maxLength: 1000,
      placeholder: 'Escreva sobre o que gostaria de falar com a gente',
    },
  },
]

export default fields
